export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
export const MIXPANEL_DEBUG_MODE = process.env.REACT_APP_MIXPANEL_DEBUG_MODE || false;
